import { createContext } from 'react';

const ScheduleContext = createContext({ startTime: void 0, endTime: void 0 });

export { ScheduleContext };
//# sourceMappingURL=contexts.js.map
